var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { open: _vm.openSuggestion },
      staticStyle: { position: "relative" }
    },
    [
      _c("input", {
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.updateValue($event.target.value)
          },
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.enter.apply(null, arguments)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              return _vm.down.apply(null, arguments)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              return _vm.up.apply(null, arguments)
            }
          ]
        }
      }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "dropdown-menu", staticStyle: { width: "100%" } },
        _vm._l(_vm.matches, function(suggestion, index) {
          return _c(
            "li",
            {
              class: { active: _vm.isActive(index) },
              on: {
                click: function($event) {
                  return _vm.suggestionClick(index)
                }
              }
            },
            [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v(_vm._s(suggestion.label) + " "),
                _c("small", [_vm._v(_vm._s(suggestion.value))])
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d839524", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d839524","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Autocomplete.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0d839524","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Autocomplete.vue
// module chunks = 2